import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {userSearchResultStateSelector} from './user-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {UserSavedSearch} from 'src/openapi/admin/models/UserSavedSearch';
import type {UserSearchCriteria} from 'src/openapi/admin/models/UserSearchCriteria';
import type {UserSearchFiltering} from 'src/openapi/admin/models/UserSearchFiltering';
import type {UserSortField} from 'src/openapi/admin/models/UserSortField';

export const userSearchResultSavedSearchesSlice = getCachedTableDataSlice<
    Record<string, UserSavedSearch>,
    UserSearchCriteria,
    UserSortField,
    UserSearchFiltering
>('userSearchResultV2SavedSearches');

export const userSearchResultSavedSearchesActions = userSearchResultSavedSearchesSlice.actions;

const userSearchResultSavedSearchesCacheSelector: CachedTableCacheSelector<Record<string, UserSavedSearch>>
    = state => state.userSearchResult.savedSearches.cache;
export const userSearchResultSavedSearchesDataSelector: CachedTableDataSelector<Record<string, UserSavedSearch>>
    = state => state.userSearchResult.savedSearches;
export const userSearchResultSavedSearchesResultSelector = getCachedTableResultSelector(
    userSearchResultSavedSearchesCacheSelector,
    userSearchResultStateSelector,
);
